import React, { useState, useEffect } from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import logo_white from '../../assets/images/logo_white.png';

const ImageLoading = () => {
    const [showTimeoutText, setShowTimeoutText] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowTimeoutText(true);
        }, 18000);

        return () => clearTimeout(timer);
    }, []);

    if (showTimeoutText) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    backgroundColor: '#f5f5f5',
                }}
            >
                <Typography variant="h5" color="textSecondary" fontWeight="bold">
                    No hay información disponible
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                backgroundColor: '#1976d2',
                position: 'relative',
            }}
        >
            <Box sx={{
                position: 'absolute',
                top: 0,
                width: '100%',
                color: 'white',
                zIndex: 2,
            }}>
                <LinearProgress color="inherit" sx={{ height: '15px' }} />
            </Box>

            <Box
                component="img"
                src={logo_white}
                alt="Loading..."
                sx={{
                    width: '30%',
                    height: 'auto',
                    zIndex: 1,
                }}
            />
        </Box>
    );
};

export default ImageLoading;